const PanelFooter = ({ appConfig }) => (
  <div className="journey-info-wrapper">
    <p className="journey-template-id">(*) Campo obbligatorio</p>
    <div className="journey-container">
      <p className="journey-template-id">
        <span className="title">idPushTTL</span>
        {appConfig.idPushTTL || 'NOT FOUND'}
      </p>
      <p className="journey-template-id">
        <span className="title">JourneyID</span>
        {appConfig.idJourney || 'NOT FOUND'}
      </p>
    </div>
    <p className="journey-template-id">
      <span className="title">EventDefinitionKey</span>
      {appConfig.eventDefinitionKey || 'NOT FOUND'}
    </p>
  </div>
);

export default PanelFooter;